const getContextPath = props => {
  const { parentIndex = 0, parentKey = '' } = props;
  const hasParent = !!parentKey;
  return hasParent ? `${parentKey}[${parentIndex}].` : '';
};

export default getContextPath;
